import "../../../Assets/Css/Doctors/Dashboard.css";

import React from "react";
import { Link } from "react-router-dom";

const NavBar = () => {
  return (
    <>
      <nav className="fixed z-30 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700">
        <div className="px-3 py-3 lg:px-5 lg:pl-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-start">
              <Link to={"/"} className=" flex ml-2 md:mr-24">
                <img width={100} src="/img/final-logo.png" className="logo_nav" alt="Logo" />
              </Link>
            </div>
           
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
